import { useNavigate, useSearchParams } from "react-router";
import PageContent from "../../components/molecule/pageContent";
import { useEffect, useState } from "react";
import Flex from "../../components/atom/flex";
import { css } from "@emotion/css";

const pageCSS = css`
    #first {
        overflow: hidden;
        box-sizing: border-box;
        padding-top: 100px;
        text-align: center;
        
        &::before {
            content: '';
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            opacity: .7;
            background-repeat: no-repeat;
            background-size: cover;
            background-image: url('/img/bg_1.jpeg');
            background-position: center;
        }

        h1 {
            margin: 0;
            background-color: #734332;
            color: #ffffff;
            font-size: 3rem;
            padding: 32px;
            font-weight: 600;
            box-sizing: border-box;
        }

        h2 {
            margin: 0;
            background-color: #f1e1dd;
            color: #cc4331;
            font-family: Comfortaa, Arial;
            font-weight: normal;
            padding: 32px;
            box-sizing: border-box;
        }

        #inner-content {
            position: relative;
            padding: 50px;
            box-sizing: border-box;

            &::before {
                content: '';
                position: absolute;
                top: -5px;
                left: -5px;
                z-index: -1;
                width: calc(100% + 10px);
                background-image: url('/img/bg_3.jpeg');
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                height: calc(100% + 15px);
                opacity: 0.85;
                filter: blur(4px);
            }

            img {
                flex: 1;
                min-width: 200px;
                border: 2px solid #c39b54;
                border-radius: 20px;
                box-shadow: 2px 2px 10px #c39b54;    
                transition: 0.3s; 
                
                &:hover {
                    box-shadow: 4px 4px 10px #c39b54; 
                    transform: scale(1.01);
                    transition: 0.3s; 
                }
            }

            div {
                flex: 1;
                text-align: start;
                color: #ffffff;
                font-size: 1.2rem;
                text-align: center;

                label {
                    display: block;
                    font-size: 2.5rem;
                    font-family: Caveat, Arial;
                    width: 100%;
                }
                
                p {
                    line-height: 40px;
                    font-weight: 700;
                    min-width: 200px;
                }

                a {
                    display: block;
                    color: #ffffff;
                    font-weight: bold;
                    font-size: 1.5rem;
                    margin-top: 100px;
                    text-align: center;
                }
            }
        }
    }

    #second {
        background-color: #734332;
        padding: 10%;
        box-sizing: border-box;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 100px;

        img {
            width: 100%;
            border: 1px solid #c39b54;
            border-radius: 10px;
        }
    }
`;

const MemoriasDaAlma = () => {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const [activeKey, setActiveKey] = useState(false);

    let specialButton;

    if(activeKey) {
        specialButton = css`
            position: relative;
            color: #ffffff; 
            padding: 2px;
            border-radius: 5px;
            box-sizing: border-box;
            font-weight: bold;
            box-shadow: 0px 0px 7px #c39b54;    
            transition: 0.3s; 
            overflow: hidden;
            text-decoration: none;
            margin-top: 40px;

            &::before {
                content: '';
                position: absolute;
                left: -25%;
                top: -175%;
                width: 150%;
                height: 500%;
                background: linear-gradient(135deg, #a17624 0%, #ce9f56 33%, #6b4c12 66%, #000000 100%);
                animation: special-button 10s ease infinite;
            }

            div {
                position: relative;
                background: linear-gradient(270deg, #0b112c 0%, #171c47 80%, #28224b 100%);
                border-radius: 5px;
                padding: 0px 10px;    
                height: 50px;
                width: 200px;
                line-height: 50px;
                text-align: center !important;
            }
            
            &:hover {
                box-shadow: 0px 0px 10px #c39b54; 
                transform: scale(1.1);
                transition: 0.3s; 
            }
        `;
    }

    useEffect(() => {
        const bookKey = searchParams.get('key');
        console.log('bookKey:', bookKey);
        if(bookKey) {
            localStorage.setItem('memorias_da_alma_key', bookKey);
            navigate('/memorias-da-alma/oculto/home/#lobby', { replace: true });

            window.location.reload();
        } else {
            const storedKey = localStorage.getItem('memorias_da_alma_key');
            
            if(storedKey) {
                setActiveKey(true);
            }
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(<div className={pageCSS}>
        <PageContent id="first">
            <h1>MEMÓRIAS DA ALMA</h1>
            <h2>Maysa De Cesaro</h2>
            <Flex
                wrap
                id="inner-content"
                align="center"
                justify="space-between"
                gap={30}
            >
                <img 
                    src="/img/memorias_da_alma_capa.jpeg"
                    alt="capa-livro"
                />
                <div>
                    <label>
                        Há histórias que terminam na última<br/>
                        página, outras apenas mudam de lugar.
                    </label>
                    <p>
                        Há conexões que  não começam aqui. Apenas se reconhecem.<br/>
                        Uma história sobre saudade, destino, arte e os<br/>
                        mistérios que habitam além da memória.
                    </p>
                    <p>
                        Quando se recorda das memórias da alma, o<br/>
                        universo começa a alinhar caminhos que já<br/>
                        estavam escritos no invisível. As almas destinadas<br/>
                        finalmente se reconhecem no silêncio.
                    </p>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.amazon.com.br/dp/B0H51G62QQ?ref=cm_sw_r_ffobk_cso_wa_mwn_dp_R1NQZC5MSDXX5BW0QG2K&ref_=cm_sw_r_ffobk_cso_wa_mwn_dp_R1NQZC5MSDXX5BW0QG2K&social_share=cm_sw_r_ffobk_cso_wa_mwn_dp_R1NQZC5MSDXX5BW0QG2K&bestFormat=true&fbclid=PAb21jcATXDh5leHRuA2FlbQIxMQBzcnRjBmFwcF9pZA81NjcwNjczNDMzNTI0MjcAAadiXYiezAuXCDZ_OnM-_FegQ0AKbtPdEQueU3SiL1xDxGtDCsIby6k2WcSuQA_aem_aOLv8xw7kBVzNajv_gAFJw&utm_content=link_in_bio&utm_medium=social&utm_source=ig">
                        ADQUIRA O LIVRO AQUI.
                    </a>
                    <Flex justify="center">
                        {activeKey && <a href="/memorias-da-alma/oculto/home/#lobby" className={specialButton}><div>ARQUIVO OCULTO</div></a>}
                    </Flex>
                </div>
            </Flex>
        </PageContent>
        <PageContent id="second">
            <img 
               src="/img/bg_4.jpeg"
               alt="background"
            />
        </PageContent>
    </div>);
}

export default MemoriasDaAlma;